export const applications = [
  {
    name: "Movie Night Fight",
    description:
      "A mobile-first app for groups of movie lovers who can never figure out which movie to watch when it's their turn to choose. It keeps track of whose turn it is to choose the evening's entertainment, and allows each person to keep a curated list of movies to choose from when it's their turn.",
    stack: ["React", "Flask", "PostgreSQL", "Flask Migrate", "React-Spring"],
    github: ["https://github.com/seanyboy49/movie-night-fight"],
    deployed: ["https://movienightfight.herokuapp.com/public/home"],
    images: [
      "mnf-stack.png",
      "mnf-search.png",
      "mnf-house.png",
      "mnf-login.png",
    ],
  },
  {
    name: "TiniURL",
    description:
      "TiniURL is a full-stack web application that provide short aliases redirecting to long URLs. Users convert long URLs into shorter links that redirect to the original URL.",
    stack: ["React", "Flask", "PostgreSQL", "Styled-Components"],
    github: ["https://github.com/JinaZhu/tiny_url"],
    deployed: ["https://tiniurl.herokuapp.com/"],
    images: ["tini-home.png", "tini-convert.png", "tini-data.png"],
  },
  {
    name: "Qrzn",
    description:
      "Qrzn is the brainchild of JG Debray, a designer based in New York. JG came up with the idea of an online magazine for him and other designers/artists/writers to provide commentary on the ongoing pandemic through different forms of media.",
    stack: ["React", "Gatsby", "GraphQL", "Netlify"],
    github: ["https://github.com/seanyboy49/quaranzine"],
    deployed: "https://qrzn.org/",
    images: ["qrzn-cover.png", "qrzn-archive.png", "qzrn-awesome-graphic.png"],
  },
  {
    name: "Trivia",
    description:
      "Test your knowledge and play a round of trivia! If you have an awesome trivia question, add it to the game bank.",
    stack: ["React", "Flask", "SQLAlchemy"],
    github: [
      "https://github.com/JinaZhu/trivia-game",
      "https://github.com/JinaZhu/trivia-backend",
    ],
    deployed: "https://triviaknowledge.herokuapp.com/",
    images: ["trivia-home.png", "trivia-play.png", "trivia-add.png"],
  },
  {
    name: "Adventure Awaits",
    description:
      "Adventure Awaits is a full-stack web application that allows anyone to discover somewhere new by providing an insight into a country. Let it do the research for you before booking.",
    stack: ["React", "Flask", "PostgreSQL", "Chart.js"],
    github: ["https://github.com/JinaZhu/World-Traveler"],
    deployed: "",
    images: [
      "aa-homepage.png",
      "aa-pictures.png",
      "aa-travel-info.png",
      "aa-places-been.png",
    ],
  },
  {
    name: "Cocktail Hour",
    description:
      "In the mood for a cocktail, but too lazy to head to the store? Discover a cocktail to make with locally home available ingredients with Cocktail Hour. Find and save cocktails for later use.",
    stack: ["React", "Flask", "SQLAlchemy"],
    github: [
      "https://github.com/JinaZhu/cocktail-frontend",
      "https://github.com/JinaZhu/Cocktail-Backend",
    ],
    deployed: "",
    images: ["cocktail-home.png", "cocktail-search.png", "cocktails.png"],
  },
  {
    name: "Cake-Tac-Toe",
    description: "A simple game of Tic-Tac-Toe with 🎂 and 😻.",
    stack: ["React", "Styled Components"],
    github: ["https://github.com/JinaZhu/Tic-Tac-Toe/tree/master/src"],
    deployed: "https://caketactoe.herokuapp.com/",
    images: ["cake-unplayed.png", "cake-played.png"],
  },
];
